/* eslint-disable */
export const validateUrlAddress = (rule, value, callback) => {
    try {
        // eslint-disable-next-line no-new
        new URL(value);
    } catch (e) {
        callback('Invalid domain');
    }
};

export const validateDomain = (rule, value, callback) => {
    if (!value || value.length === 0) {
        return;
    }

    const validateDomainRegexp =
        /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

    try {
        const regexp = new RegExp(validateDomainRegexp);
        if (!regexp.test(value)) {
            throw Error();
        }
    } catch (e) {
        callback('Invalid domain');
    }
};

export const PASSWORD_MIN_LENGTH = 8;

// ^	The password string will start this way
// (?=.*[a-z])	The string must contain at least 1 lowercase alphabetical character
// (?=.*[A-Z])	The string must contain at least 1 uppercase alphabetical character
// (?=.*[0-9])	The string must contain at least 1 numeric character
export const policyRegex = new RegExp(
    `^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{${PASSWORD_MIN_LENGTH},})`
);
export const uppercaseRegex = new RegExp('^(?=.*[A-Z])');
export const numericRegex = new RegExp('(?=.*[0-9])');
